import { useCallback } from "react";
import * as ReactRouter from "react-router-dom";

interface NavigateFunction {
  (url: string): void;
}

export function useNavigate(): NavigateFunction {
  const navigate = ReactRouter.useNavigate();
  const location = ReactRouter.useLocation();
  return useCallback(
    url => {
      window.scrollTo(0, 0);
      navigate(url + location.search);
    },
    [location.search]
  );
}
